export { default as shansongStudy } from './shansongStudy'
export { default as recruit } from './recruit'
export { default as equipCertification } from './equipCertification'
export { default as recruitInfoCollection } from '@/pages/recruit/InfoCollection/model'
export { default as indexesCitySelect } from '@/pages/indexesCitySelect/model'
export { default as indexesCityList } from '@/pages/components/IndexesCityList/model'
export { default as serviceScore } from '@/pages/serviceScore/home/model'
export { default as detail } from '@/pages/serviceScore/detail/model'
export { default as scoreRecord } from '@/pages/serviceScore/scoreRecord/model'
export { default as changeRecord } from '@/pages/serviceScore/changeRecord/model'
export { default as serviceScoreRules } from '@/pages/serviceScore/rules/model'
export { default as formula } from '@/pages/serviceScore/components/formula/model'
export { default as insuranceMain } from '@/pages/insurance/main/model'
export { default as clockInFinish } from '@/pages/freeCard/clockInFinish/model'
export { default as rewardCenterDetail } from '@/pages/rewardCenter/detail/model'
export { default as rewardCenterList } from '@/pages/rewardCenter/list/model'
export { default as cashAccount } from '@/pages/wallet/cashAccount/model'
export { default as cashDetail } from '@/pages/wallet/cashDetail/model'
export { default as cashOut } from '@/pages/wallet/cashOut/model'
export { default as newCashOut } from '@/pages/wallet/newCashOut/model'
export { default as cashRecord } from '@/pages/wallet/cashRecord/model'
export { default as order } from '@/pages/order/index/model'
export { default as incomeDetail } from '@/pages/wallet/incomeDetail/model'
export { default as bankCard } from '@/pages/wallet/bankCard/model'
export { default as helpBuyAccount } from '@/pages/wallet/helpBuyAccount/model'
export { default as accountRecharge } from '@/pages/wallet/accountRecharge/model'
export { default as applyChangeCity } from '@/pages/recruit/applyChangeCity/model'
export { default as entry } from '@/pages/recruit/entry/model'
export { default as equipmentPayInfo } from '@/pages/recruit/equipmentPayInfo/model'
export { default as equipmentPayInfoNew } from '@/pages/recruit/equipmentPayInfoNew/model'
export { default as editAddress } from '@/pages/recruit/editAddress/model'
export { default as main } from '@/pages/recruit/main/model'
export { default as selectCity } from '@/pages/recruit/selectCity/model'
export { default as waitReceiving } from '@/pages/recruit/waitReceiving/model'
export { default as sureReceiving } from '@/pages/recruit/sureReceiving/model'
export { default as certificationDesc } from '@/pages/recruit/certificationDesc/model'
export { default as weedout } from '@/pages/recruit/weedout/model'
export { default as alreadyLogOff } from '@/pages/recruit/alreadyLogOff/model'
export { default as myInfo } from '@/pages/recruit/myInfo/model'
export { default as healthCertification } from '@/pages/recruit/healthCertification/model'
export { default as voiceCertification } from '@/pages/recruit/voiceCertification/model'
export { default as waitingAudit } from '@/pages/recruit/waitingAudit/model'
export { default as home } from '@/pages/sendOrders/home/model'
export { default as activityCenter } from '@/pages/activityCenter/model'
export { default as messageHome } from '@/pages/messageCenter/messageHome/model'
export { default as messageDetail } from '@/pages/messageCenter/messageDetail/model'
export { default as rechargePay } from '@/pages/rechargePay/model'
export { default as faqDetail } from '@/pages/customerService/faqDetail/model'
export { default as complainsRecords } from '@/pages/customerService/complainsRecords/model'
export { default as complainsDetail } from '@/pages/customerService/complainsDetail/model'
export { default as annex } from '@/pages/customerService/annex/model'
export { default as appealRecords } from '@/pages/customerService/appealRecords/model'
export { default as appealDetail } from '@/pages/customerService/appealDetail/model'
export { default as punishList } from '@/pages/customerService/punishList/model'
export { default as appealReason } from '@/pages/customerService/appealReason/model'
export { default as customerServiceHome } from '@/pages/customerService/home/model'
export { default as equipmentAudit } from '@/pages/equipmentAudit/model'
export { default as shCommitment } from '@/pages/shCommitment/model'
export { default as selectRecruitType } from '@/pages/recruit/selectRecruitType/model'
export { default as enrollEquipment } from '@/pages/recruit/enrollEquipment/model'
export { default as sureIdentity } from '@/pages/recruit/sureIdentity/model'
export { default as mallHome } from '@/pages/equipmentMall/mallHome/model'
export { default as mallDetail } from '@/pages/equipmentMall/mallDetail/model'
export { default as mallList } from '@/pages/equipmentMall/mallList/model'
export { default as sureOrder } from '@/pages/equipmentMall/sureOrder/model'
export { default as checkStation } from '@/pages/equipmentMall/checkStation/model'
export { default as checkAddress } from '@/pages/equipmentMall/checkAddress/model'
export { default as mallOrder } from '@/pages/equipmentMall/orderList/model'
export { default as mallOrderDetail } from '@/pages/equipmentMall/orderDetail/model'
export { default as trainingSite } from '@/pages/trainingSite/model'
export { default as records } from '@/pages/recommendAwards/records/model'
export { default as qrCode } from '@/pages/scanToOrder/qrCode/model'
export { default as downLoad } from '@/pages/scanToOrder/downLoad/model'
export { default as noviceGuide } from '@/pages/noviceGuide/model'
export { default as checkVehicle } from '@/pages/recruit/checkVehicle/model'
export { default as vehicleInfo } from '@/pages/recruit/vehicleInfo/model'
export { default as vehicleWaiting } from '@/pages/recruit/vehicleWaiting/model'
export { default as myVehicle } from '@/pages/myVehicle/model'
export { default as suppliersList } from '@/pages/suppliersList/model'
export { default as waitingVerified } from '@/pages/waitingVerified/model'
export { default as subtasks } from '@/pages/rewardCenter/subtasks/model'
export { default as cancelReason } from '@/pages/order/cancelReason/model'
export { default as newCancelReason } from '@/pages/order/newCancelReason/model'
export { default as newCancelReasonRetain } from '@/pages/order/newCancelReasonRetain/model'
export { default as bjCommitment } from '@/pages/commitment/bjCommitment/model'
export { default as panJinCommitment } from '@/pages/commitment/panJinCommitment/model'
export { default as goldExplain } from '@/pages/gold/goldExplain/model'
export { default as goldDetail } from '@/pages/gold/goldDetail/model'
export { default as myPropBag } from '@/pages/widget/myWidgetBag/model'
export { default as myPropDetail } from '@/pages/widget/myWidgetDetail/model'
export { default as voidProp } from '@/pages/widget/voidWidget/model'
export { default as propExplain } from '@/pages/widget/widgetExplain/model'
export { default as backhaulSettings } from '@/pages/widget/backhaulSettings/model'
export { default as repairSignin } from '@/pages/widget/repairSigninSettings/model'
export { default as acceptOrderSettings } from '@/pages/widget/acceptOrderSettings/model'
export { default as myLevel } from '@/pages/levelSys/myLevel/model'
export { default as myLevelRecord } from '@/pages/levelSys/myLevelRecord/model'
export { default as fullLevel } from '@/pages/levelSys/fullLevel/model'
export { default as finishYears } from '@/pages/levelSys/finishYears/model'
export { default as experienceDetails } from '@/pages/levelSys/experienceDetails/model'
export { default as levelDesc } from '@/pages/levelSys/levelDesc/model'
export { default as customerServiceChat } from '@/pages/customerService/chat/model'
export { default as shansongValueHome } from '@/pages/shansongValue/home/model'
export { default as shansongValueRecord } from '@/pages/shansongValue/record/model'
export { default as shansongValueExplain } from '@/pages/shansongValue/explain/model'
export { default as honourKnightHome } from '@/pages/honourKnight/home/model'
export { default as honourKnightHistory } from '@/pages/honourKnight/record/model'
export { default as penaltyRecord } from '@/pages/penaltyRecord/model'
export { default as widgetMallHome } from '@/pages/widgetMall/widgetMallHome/model'
export { default as widgetMallDetail } from '@/pages/widgetMall/widgetMallDetail/model'
export { default as widgetMallList } from '@/pages/widgetMall/widgetMallList/model'
export { default as widgetMallSureOrder } from '@/pages/widgetMall/widgetMallSureOrder/model'
export { default as widgetMallOrderPaySuccess } from '@/pages/widgetMall/widgetMallOrderPaySuccess/model'
export { default as widgetMallRecordList } from '@/pages/widgetMall/widgetMallRecordList/model'
export { default as widgetMallCoupon } from '@/pages/widgetMall/widgetMallCoupon/model'
export { default as widgetMallExpireCoupon } from '@/pages/widgetMall/widgetMallExpireCoupon/model'
export { default as widgetMallCheckCoupon } from '@/pages/widgetMall/widgetMallCheckCoupon/model'
export { default as explain } from '@/pages/honourKnight/explain/model'
export { default as introduction } from '@/pages/longPartner/introduction/model'
export { default as levelRule } from '@/pages/longPartner/levelRule/model'
export { default as blessingValue } from '@/pages/longPartner/blessingValue/model'
export { default as longPartnerHome } from '@/pages/longPartner/home/model'
export { default as eleCarQuestionnaire } from '@/pages/eleCarQuestionnaire/model'

export { default as cardList } from '@/pages/acceleratorCard/cardList/model'
export { default as cardDetail } from '@/pages/acceleratorCard/cardDetail/model'
export { default as purchaseDetail } from '@/pages/acceleratorCard/purchaseDetail/model'
export { default as buyRecordList } from '@/pages/acceleratorCard/buyRecordList/model'
export { default as surePay } from '@/pages/acceleratorCard/surePay/model'
export { default as unbindAlipay } from '@/pages/wallet/unbindAlipay/model'

export { default as transfer } from '@/pages/wallet/transfer/model'
export { default as ecommendMessengerHome } from '@/pages/recommendMessenger/home/model'
export { default as friendDetail } from '@/pages/recommendMessenger/friendDetail/model'
export { default as recommendList } from '@/pages/recommendMessenger/recommendList/model'
export { default as invitationRecord } from '@/pages/recommendMessenger/invitationRecord/model'
export { default as rewardRecord } from '@/pages/recommendMessenger/rewardRecord/model'
export { default as ruleDetails } from '@/pages/recommendMessenger/ruleDetails/model'
export { default as recommendRegister } from '@/pages/recommendMessenger/recommendRegister/model'
export { default as studyTask } from '@/pages/shansongStudy/studyTask/model'
export { default as studyRecord } from '@/pages/shansongStudy/studyRecord/model'
export { default as studySearch } from '@/pages/shansongStudy/studySearch/model'
export { default as studyLimitTask } from '@/pages/shansongStudy/studyLimitTask/model'
export { default as recommendUserhome } from '@/pages/recommendUser/home/model'
export { default as historyRecord } from '@/pages/recommendUser/historyRecord/model'
export { default as activityRule } from '@/pages/recommendUser/activityRule/model'
export { default as userRecommendRecord } from '@/pages/recommendUser/userRecommendRecord/model'
export { default as userRewardRecord } from '@/pages/recommendUser/userRewardRecord/model'
export { default as activityGuide } from '@/pages/recommendUser/activityGuide/model'
export { default as recommendDetail } from '@/pages/recommendUser/recommendDetail/model'
export { default as buyRecord } from '@/pages/insurance/buyRecord/model'
export { default as commonSmartCaptcha } from '@/pages/components/commonSmartCaptcha/model'
export { default as taskCenter } from '@/pages/courierTask/taskCenter/model'
export { default as taskDetail } from '@/pages/courierTask/taskDetail/model'
export { default as joinWechat } from '@/pages/recruit/joinWechat/model'
export { default as forceSurvey } from '@/pages/forceSurvey/model'
export { default as equipmentSurePay } from '@/pages/recruit/equipmentSurePay/model'

export { default as transferApply } from '@/pages/accidentTransfer/transferApply/model'
export { default as carRescue } from '@/pages/accidentTransfer/carRescue/model'
export { default as transferFail } from '@/pages/accidentTransfer/transferFail/model'
export { default as couponCollectionCenter } from '@/pages/equipmentMall/couponCollectionCenter/model'
export { default as middleJump } from '@/pages/middleJump/model'

export { default as equipmentPayInfoNewTwo } from '@/pages/recruit/equipmentPayInfoNewTwo/model'
export { default as issProvinceCityArea } from '@/pages/components/IssProvinceCityArea/model'

export { default as ensureIncome } from '@/pages/rewardCenter/ensureIncome/model'
export { default as eTravelTransfer } from '@/pages/swapElectricity/eTravelTransfer/model'

export { default as valueRuleInfo } from '@/pages/shansongValue/v2/ruleInfo/model'
export { default as valueExplainInfo } from '@/pages/shansongValue/v2/explainInfo/model'
export { default as valueHome } from '@/pages/shansongValue/v2/valueHome/model'
export { default as shansongValueValueDetail } from '@/pages/shansongValue/v2/valueDetail/model'
export { default as shansongValueScoreList } from '@/pages/shansongValue/v2/valueList/model'

export { default as serviceScoreRuleInfo } from '@/pages/serviceScore/v2/ruleInfo/model'
export { default as violationBill } from '@/pages/serviceScore/v2/violationBill/model'
export { default as serviceScoreViolateInfo } from '@/pages/serviceScore/v2/violateInfo/model'
export { default as serviceScoreMain } from '@/pages/serviceScore/v2/main/model'
export { default as serviceScoreDetail } from '@/pages/serviceScore/v2/detail/model'
export { default as commitment } from '@/pages/serviceScore/v2/commitment/model'
export { default as siteSelection } from '@/pages/serviceScore/v2/siteSelection/model'

export { default as mallSearchPage } from '@/pages/equipmentMall/mallSearchPage/model'

export { default as knightRankingList } from '@/pages/honourKnight/knightRankingList/model'
export { default as accountLogoff } from '@/pages/wallet/accountLogoff/model'
export { default as dalianProve } from '@/pages/courierProve/dalianProve/model'

export { default as activityList } from '@/pages/equipmentMall/activityList/model'

export { default as attendScoreRecord } from '@/pages/honourKnight/attendScoreRecord/model'

export { default as taskList } from '@/pages/honourKnight/taskList/model'

export { default as attendScoreRule } from '@/pages/honourKnight/attendScoreRule/model'

export { default as logisticsList } from '@/pages/equipmentMall/logisticsList/model'

export { default as jumpQueue } from '@/pages/recruit/jumpQueue/model'

export { default as jumpQueueCompleted } from '@/pages/recruit/jumpQueueCompleted/model'
export { default as bankCardList } from '@/pages/wallet/bankCardList/model'

export { default as helmetAuditHome } from '@/pages/helmetAudit/helmetAuditHome/model'

export { default as helmetGather } from '@/pages/helmetAudit/helmetGather/model'

export { default as serviceFeeDetails } from '@/pages/wallet/serviceFeeDetails/model'

export { default as sign } from '@/pages/shansongValue/v2/sign/model'
